<template>
    
    <div  class="  ac-transition">
        <div class="card print-card">
              <button type="reset" @click="printReceipt" class="btn b-light btn-danger-light btn-sm">Print Receipt</button>
             
        </div>
        <div class="grid grid-cols-12 bg-white">
          <div id="receipt"  class="receipt">
            <div class="receipt-container  ">
              <div class="border"></div>


         <div v-if="measurement_details && measurement_details.length" id="receipt">

        <div v-for="(item, index) in measurement_details" :key="item.id" class="border">

          <div class="card p-0 mt-2">
            <div class="card-body">


        <div class="  x-font-bold">Bill No: {{ item.invoiceno }}</div> 
              
             <div class="row-simple">
                <strong>Date: {{ item.entry_date }}</strong>
              </div>
            <div class="delivery_date">
                Delivery Dt:  {{item.deliverydate}} 
            </div>
            
                <div class="d-flex x-font">
                <template  v-if="item.halfshirt > 0 || item.fullshirt > 0">
                    <div class=" "> 
                        {{item.stitching_label }} : {{ Number(item.halfshirt??0)+Number(item.fullshirt??0) }}  
                        (<span v-if="item.fullshirt > 0">{{item.fullshirt}} फुल  </span>
                        <span v-if="item.halfshirt > 0">  {{item.halfshirt}} हाफ  </span>)
                    
                    </div>
                </template>
                
                 
                   <strong v-if="item.pant > 0">  {{item.stitching_label }} :  ({{ item.pant }})</strong>
                 
                    
                   </div>
          

                  <hr style="border:1px dashed black;">



             <!-- SHIRT -->
                <div v-if="item.halfshirt > 0 || item.fullshirt > 0">

                  <!-- <div><strong>{{ index + 1 }}. Shirt ({{ item.halfshirt || item.fullshirt }})</strong></div> -->
                  <div class="mt-1"> <h3 style="text-transform: capitalize;border: 1px solid black;padding-left: 10px;">{{item.customer_name}}</h3></div>

                  <div class="plain-measurement" v-if="getValues(item).length">

                    <div>{{ getValues(item)[0] }}</div>

                    <div class="row3 ">
                      <span style="">{{ getValues(item)[1] }}</span>
                      <span style="">{{ getValues(item)[2] }}</span>
                      <span style="">{{ getValues(item)[3] }}</span>
                    </div>

                    <div class="row3 ">
                      <span style="">{{ getValues(item)[4] }}</span>
                      <span style="">{{ getValues(item)[5] }}</span>
                      <span style="">{{ getValues(item)[6] }}</span>
                    </div>

                    <div>{{ getValues(item)[7] }}</div>

                    <div class="row4 ">
                      <span style="">{{ getValues(item)[8] }}</span>
                      <span style="">{{ getValues(item)[9] }}</span>
                      <span style="">{{ getValues(item)[10] }}</span>
                      <span style="">{{ getValues(item)[11] }}</span>
                    </div>

                    <div>{{ getValues(item)[12] }}</div>
                    <div>{{ getValues(item)[13] }}</div>

                  </div>
                </div>


                <!-- PANT -->
                <div v-if="item.pant > 0">

                  <div class="mt-1"> <h3 style="text-transform: capitalize;border: 1px solid black;padding-left: 10px;">{{item.customer_name}}</h3></div>
                  <div><strong>{{ item.stitching_label }}</strong></div>

                  <div class="plain-measurement" v-if="getValues(item).length">

                    <div>{{ getValues(item)[0] }}</div>

                    <div>{{ getValues(item)[1] }}</div>
                    <div>{{ getValues(item)[2] }}</div>
                    <div>{{ getValues(item)[3] }}</div>

                    <div class="row2">
                      <span>{{ getValues(item)[4] }}</span>
                      <span>{{ getValues(item)[5] }}</span>
                    </div>

                    <div>{{ getValues(item)[6] }}</div>
                    <div>{{ getValues(item)[7] }}</div>

                  </div>
                </div>











                    <span>{{ item.measurementnote }}</span>

 <div class="trial_date">
                Trial Dt: {{(item?.trialdate=='0000-00-00')?'':item?.trialdate}}
            </div>



          </div>
           </div>

        

        </div>

      </div>

    </div>
  </div>
        </div>
        </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '',
      customer:[],
      invDetails:[],
      measurement_details:[], 
      order_items_under:[],
      measurements:[],
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
     async getBasics(invoiceid) {
           var self=this;
             axios.post('get_new_measurement_print',{invoiceid:invoiceid}).then(function (response) {
                         self.measurement_details=response.data.measurement_details;
                         self.employees=response.data.userDetails;
                         self.invDetails=response.data.invDetails;
                         self.customer=response.data.customer;
                        self.order_items_under=response.data.order_items_details;
                        try {
                            document.getElementById("loader").remove();  
                          // self.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 
                      
                        
                        
                  
                        });;
      },
    formatCurrency(value) {
      return value;//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },
 
     getValues(item) {
    try {
      return JSON.parse(item.lablevalue || "[]");
    } catch (e) {
      return [];
    }
  }













  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@200;500&display=swap');

 
.x-font-bold{
      font-weight: 600;
    padding-top: 5px;
    font-size: 18px;
    padding-bottom: 5px;
}
.x-font{
    padding-top: 5px;
    font-size: 18px;
    padding-bottom: 5px;
}
.row-measurementqty {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 600;
}
.row-simple {
  font-size: 14px;
}
.delivery_date{
    font-size: 14px;
  font-weight: 600;
}
.row-between {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
}
.trial_date {
font-size: 18px;
    margin-top: 10px;
    font-weight: 700;
}
.plain-measurement { 
  margin-top: 6px;
  font-family: monospace;
  line-height: 2.2;
  font-size: 19px;
}

/* spacing exactly like image */
.row2 {
  display: flex;
  justify-content: space-between;
  width: 100px;
}

.row3 {
  display: flex;
  justify-content: space-between;
  width: 160px;
}

.row4 {
  display: flex;
  justify-content: space-between;
  width: 200px;
}

.plain-measurement span {
  display: inline-block;
  min-width: 40px;
  
}

/* highlight (pant first box) */
.highlight {
  background: yellow;
  display: inline-block;
  padding: 2px 6px;
}









.dn_f { 
  font-family: 'Noto Sans Devanagari', sans-serif;
  font-size: 14px;
}
.dn_f_only { 
  font-family: 'Noto Sans Devanagari', sans-serif;
}
tbody,table,.border{
    border-bottom: 1px dashed;
}
 #receipt {
  font-family: monospace;
  font-size: 16px;
  width: 72mm; /* Common width for thermal printers */
  padding: 5px;
}
table {
  width: 100%;
}
td, th {
  padding: 5px;
  text-align: left;
}


@media print {
    .note_for_item{
        text-wrap-mode: wrap;
    }
  button {
    display: none;
  }
  .print-card{
      display: none;
  }
 body {
      margin-top:10px;
        /*margin: -2rem 0 0 0;*/
        }
 /*#receipt {*/
 /*  width: 78mm;  */
 /* font-family: Arial, sans-serif;*/
 /* font-size: 12px;*/
 /* line-height: 1.4;*/
 /* padding: 5px;*/
   
 /* margin: 0 auto;*/
 /* margin-top: -40px ;*/
 /* margin-left: 10px ;*/
 /* white-space: nowrap; */
 /*   }*/
    
    .dn_f_only{
      font-size: 16px;
      font-weight: 800;
    }
    .dn_f{
      font-size: 14px;
      
    }
}


</style>
